<div class="td-wb-layout__activity_indicator">
  <div class="td-wb-layout__container"
       [class.td-wb-layout__container--fine-print]="hasFinePrints()">
    @if (showDesktopMenu()) {
      <td-wb-menu [isLocalMenuEnabled]="isLocalMenuEnabled()"/>
    }
    @if (showMobileMenu()) {
      <td-wb-mobile-menu/>
    }
    @if (showFabMenu()) {
      <td-wb-fab-menu/>
    }
    <td-wb-global-notification-banner class="td-wb-layout__global-navigation-banner"/>
    <div id="td-wb-content"
         role="main"
         tabindex="-1"
         class="td-wb-layout__page-container">
      <ng-content/>
    </div>
  </div>
  <td-wb-responsive-option/>
  <!-- Fine prints at the bottom of the page -->
  <td-wb-fine-print/>
  <td-wb-menu-footer [isHidden]="isFooterHidden()">
    @if (showManagePreferencesLink) {
      <ng-container extraLinks>
        <a class="ot-sdk-show-settings td-wb-layout__link-item"
           tabindex="0"
           translate="tdWb.components.layout.MANAGE_PREFERENCES.label"></a>
      </ng-container>
    }
  </td-wb-menu-footer>
  <td-wb-chat/>
</div>
